import React from "react";

interface DimensionFixedProps {
  className?: string;
}

const DimensionFixed: React.FC<DimensionFixedProps> = ({ className }) => {
  return (
    <svg
      width="6"
      height="12"
      viewBox="0 0 6 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.5 11H5C4.46957 11 3.96086 10.7893 3.58579 10.4142C3.21071 10.0391 3 9.53043 3 9M3 9V3M3 9C3 9.53043 2.78929 10.0391 2.41421 10.4142C2.03914 10.7893 1.53043 11 1 11H0.5M3 9V8.5M3 3C3 2.46957 3.21071 1.96086 3.58579 1.58579C3.96086 1.21071 4.46957 1 5 1H5.5M3 3C3 2.46957 2.78929 1.96086 2.41421 1.58579C2.03914 1.21071 1.53043 1 1 1H0.5M3 3V3.5"
        stroke="#1E293B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DimensionFixed;
